export type FileFormat =
  | "CSV"
  | "PDF"
  | "JSON"
  | "PNG"
  | "JPEG"
  | "JPG"
  | "GIF"
  | "WEBP";

export function downloadFile(
  content: string,
  name?: string,
  format: FileFormat = "CSV"
) {
  let formattedContent: string;
  const mimeTypes: Record<FileFormat, string> = {
    CSV: "text/csv",
    PDF: "application/pdf",
    JSON: "application/json",
    PNG: "image/png",
    JPEG: "image/jpeg",
    JPG: "image/jpeg",
    GIF: "image/gif",
    WEBP: "image/webp",
  };

  // Default file extensions
  const defaultNames: Record<FileFormat, string> = {
    CSV: "my_data.csv",
    PDF: "document.pdf",
    JSON: "data.json",
    PNG: "image.png",
    JPEG: "image.jpeg",
    JPG: "image.jpg",
    GIF: "image.gif",
    WEBP: "image.webp",
  };

  // Set default name if not provided
  name = name || defaultNames[format];

  // Handle Base64 content
  if (/^[A-Za-z0-9+/]+[=]{0,2}$/.test(content)) {
    // For images and PDFs, we can use the base64 data directly
    if (format !== "CSV" && format !== "JSON") {
      formattedContent = `data:${mimeTypes[format]};base64,${content}`;
    } else {
      // For CSV and JSON, decode the base64 content
      formattedContent =
        format === "CSV"
          ? "data:text/csv;charset=utf-8," + encodeURIComponent(atob(content))
          : "data:application/json;charset=utf-8," +
            encodeURIComponent(atob(content));
    }
  } else {
    // Handle non-base64 content
    if (format === "CSV" || format === "JSON") {
      formattedContent = `data:${
        mimeTypes[format]
      };charset=utf-8,${encodeURIComponent(content)}`;
    } else {
      // For other formats, assume content is already in correct format
      formattedContent = content.startsWith("data:")
        ? content
        : `data:${mimeTypes[format]};base64,${content}`;
    }
  }

  // Create and trigger download
  const link = document.createElement("a");
  link.setAttribute("href", formattedContent);
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); // Clean up the DOM
}
